import { DEFAULT_GC_TIME } from '@/client/constants';
import type { ProxyMetricsSnapshot } from '@/client/types/dashboard';
import { useQuery } from '@tanstack/react-query';

export const createProxyMetricsKey = () => ['dashboard', 'metrics'] as const;

async function fetchProxyMetrics(): Promise<ProxyMetricsSnapshot> {
  const response = await fetch('/metrics', {
    credentials: 'include',
    cache: 'no-store',
  });
  if (!response.ok) {
    throw new Error(`Metrics fetch failed (${response.status})`);
  }
  return response.json();
}

export const useProxyMetricsQuery = () =>
  useQuery({
    queryKey: createProxyMetricsKey(),
    queryFn: fetchProxyMetrics,
    staleTime: 15_000,
    gcTime: DEFAULT_GC_TIME,
    refetchInterval: 30_000,
  });
